module.exports = __webpack_public_path__ + "static/media/CircularXXWeb-Book.9bcc8576.woff";